/** "AI re-estimate this row" (JF 2026-09-29): the AM re-describes one fabric / trim and only that row is re-priced. */
import { useState } from "react";
import { useStore } from "../../store.ts";
import { useT } from "../../shared/i18n.ts";
import { Modal } from "../../shared/ui/common.tsx";
import { runTask } from "./reprice.ts";

export function LineAi({ line, i }: { line: "fab" | "trim"; i: number }) {
  const t = useT();
  const lang = useStore((s) => s.lang);
  const r = useStore((s) => s.sheet[line][i]);
  const { closeModal, editSheet } = useStore.getState();
  const [name, setName] = useState(r?.name || "");
  const [qual, setQual] = useState(r?.qual || "");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  if (!r) return null;
  async function go() {
    setBusy(true);
    // the new description goes on the row first, so the AI prices what the AM wrote
    editSheet((x) => { const row = x[line][i]; row.name = name; row.qual = qual; });
    const ok = await runTask("line", lang, { kind: line, i, note });
    setBusy(false);
    if (ok) closeModal();
  }
  return (
    <Modal onClose={closeModal}>
      <h3>{t("AI: re-estimate this row", "AI 重估这一行")}</h3>
      <p className="dim" style={{ margin: "0 0 12px" }}>{t("Change the description, say what should change, and only this row is re-priced against the history.",
        "改好描述、写明要改成什么，只重估这一行（对照历史价格），其他行不动。")}</p>
      <div className="fl"><label>{line === "fab" ? t("Fabric", "面料") : t("Trim", "辅料")}</label><input className="in" id="laName" value={name} onChange={(e) => setName(e.target.value)} /></div>
      <div className="fl" style={{ marginTop: 10 }}><label>{line === "fab" ? t("Quality # / content", "Quality # / 成分") : "Quality #"}</label><input className="in" id="laQual" value={qual} onChange={(e) => setQual(e.target.value)} /></div>
      <div className="fl" style={{ marginTop: 10 }}><label>{t("What should change (optional)", "要改成什么（可选）")}</label>
        <textarea className="in" id="laNote" value={note} onChange={(e) => setNote(e.target.value)} placeholder={t("e.g. polyester → nylon, same weight", "例如：聚酯纤维 → 尼龙，克重不变")} /></div>
      <div className="dim" style={{ fontSize: 12, marginTop: 8 }}>{t("Now", "现在")}: ${r.px} × {r.yld}{r.cat ? " · " + r.cat : ""}</div>
      <div className="mb">
        <button className="btn" onClick={closeModal}>{t("Cancel", "取消")}</button>
        <button className="btn p" id="laGo" disabled={busy} onClick={go}>{busy ? t("Asking the AI…", "AI 重估中…") : t("Re-estimate", "重估")}</button>
      </div>
    </Modal>
  );
}
